export enum NotificationType {
    Role = 1,
    User = 2,
    Group = 3,
}
